import { render, staticRenderFns } from "./SvgIconV2.vue?vue&type=template&id=0890b896&scoped=true"
import script from "./SvgIconV2.vue?vue&type=script&lang=js"
export * from "./SvgIconV2.vue?vue&type=script&lang=js"
import style0 from "./SvgIconV2.vue?vue&type=style&index=0&id=0890b896&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0890b896",
  null
  
)

export default component.exports